/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiCronSchedule
 */
export interface ApiCronSchedule {
  /**
   *
   * @type {Date}
   * @memberof ApiCronSchedule
   */
  start_time?: Date;
  /**
   *
   * @type {Date}
   * @memberof ApiCronSchedule
   */
  end_time?: Date;
  /**
   *
   * @type {string}
   * @memberof ApiCronSchedule
   */
  cron?: string;
}

/**
 * Check if a given object implements the ApiCronSchedule interface.
 */
export function instanceOfApiCronSchedule(value: object): value is ApiCronSchedule {
  return true;
}

export function ApiCronScheduleFromJSON(json: any): ApiCronSchedule {
  return ApiCronScheduleFromJSONTyped(json, false);
}

export function ApiCronScheduleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiCronSchedule {
  if (json == null) {
    return json;
  }
  return {
    start_time: json['start_time'] == null ? undefined : new Date(json['start_time']),
    end_time: json['end_time'] == null ? undefined : new Date(json['end_time']),
    cron: json['cron'] == null ? undefined : json['cron'],
  };
}

export function ApiCronScheduleToJSON(json: any): ApiCronSchedule {
  return ApiCronScheduleToJSONTyped(json, false);
}

export function ApiCronScheduleToJSONTyped(
  value?: ApiCronSchedule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time:
      value['start_time'] == null ? value['start_time'] : value['start_time'].toISOString(),
    end_time: value['end_time'] == null ? value['end_time'] : value['end_time'].toISOString(),
    cron: value['cron'],
  };
}
